import React from 'react';
import {StyleSheet, View} from 'react-native';
import {NavigationContainer, NavigationIndependentTree} from '@react-navigation/native';
import {ThemeProvider} from '@rn-vui/themed';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import rewardsTheme from '../../../theme/rewardsTheme';
import {OffersItemWithMflId} from '../../../transport/types';

import ExclusiveOffersTileLarge from './ExclusiveOffersTileLarge';

const mockOffer: OffersItemWithMflId = {
  mflId: 'offer-001',
  offerId: 'LM001',
  heroImage: [
    {
      id: 'hero-1',
      url: 'https://picsum.photos/seed/offer1/600/390',
      filename: 'hero.jpg',
      size: 50000,
      type: 'image',
      width: 600,
      height: 390,
    },
  ],
  heroImageDesktop: [
    {
      id: 'hero-desktop-1',
      url: 'https://picsum.photos/seed/offer1desktop/800/520',
      filename: 'hero-desktop.jpg',
      size: 80000,
      type: 'image',
      width: 800,
      height: 520,
    },
  ],
  tileHeadline: 'Save $10',
  headline: 'Weekend Special',
  description: 'Get $10 off when you spend $50 or more on selected wines.',
  tenant: ['BMT'],
  products: ['wine-001', 'wine-002'],
  barcodes: ['1234567890'],
  status: 'Approved - Live',
  offerTrigger: undefined,
};

const meta = {
  title: 'Components/Rewards/ExclusiveOffersTileLarge',
  component: ExclusiveOffersTileLarge,
  decorators: [
    Story => (
      <NavigationIndependentTree>
        <NavigationContainer>
          <ThemeProvider theme={rewardsTheme}>
            <View style={styles.container}>
              <Story />
            </View>
          </ThemeProvider>
        </NavigationContainer>
      </NavigationIndependentTree>
    ),
  ],
} satisfies Meta<typeof ExclusiveOffersTileLarge>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: mockOffer,
};

export const LongTitle: Story = {
  args: {
    ...mockOffer,
    mflId: 'offer-002',
    tileHeadline: 'Buy 2 Get 1 Free on All Premium Wines',
    description:
      'Purchase any two bottles of premium wine from our exclusive collection and receive a third bottle absolutely free. Limited time offer.',
  },
};

export const ShortContent: Story = {
  args: {
    ...mockOffer,
    mflId: 'offer-003',
    tileHeadline: '$5 Off',
    headline: 'Quick Deal',
    description: 'Save $5 on your next purchase.',
  },
};

export const AllVariants: Story = {
  render: () => (
    <View style={styles.variantsContainer}>
      <ExclusiveOffersTileLarge
        {...mockOffer}
        mflId="offer-v1"
        heroImage={[
          {
            ...mockOffer.heroImage[0],
            url: 'https://picsum.photos/seed/wine1/600/390',
          },
        ]}
        tileHeadline="Save $10"
        description="Get $10 off when you spend $50 or more."
      />
      <ExclusiveOffersTileLarge
        {...mockOffer}
        mflId="offer-v2"
        heroImage={[
          {
            ...mockOffer.heroImage[0],
            url: 'https://picsum.photos/seed/beer2/600/390',
          },
        ]}
        tileHeadline="Buy 2 Get 1 Free"
        description="On selected craft beers this weekend only."
      />
      <ExclusiveOffersTileLarge
        {...mockOffer}
        mflId="offer-v3"
        heroImage={[
          {
            ...mockOffer.heroImage[0],
            url: 'https://picsum.photos/seed/spirits3/600/390',
          },
        ]}
        tileHeadline="20% Off Spirits"
        description="All premium spirits reduced for members."
      />
    </View>
  ),
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: 'center',
  },
  variantsContainer: {
    gap: 16,
  },
});
